import React from 'react';
import ConsultantTicketListContainer from '../ConsultantTicketList/ConsultantTicketListContainer';
import * as ROUTES from '../../lib/routing/frontend';

// Unified view for both consultant tickets and broadcasts.
// suppressDefaultTypeFilter prevents injecting non-broadcast type codes automatically
// — the user controls the type filter via the showTypeFilter UI.
// paginationRoute ensures pagination links use the communications URL.
const ConsultantCommunicationsListContainer = (props) => (
  <ConsultantTicketListContainer
    {...props}
    paginationRoute={ROUTES.CONSULTANT_TICKETS.ALL_COMMUNICATIONS}
    suppressDefaultTypeFilter={true}
    showTypeFilter={true}
  />
);

export default ConsultantCommunicationsListContainer;
